import Select from '../../../ui/select';
import Text from '../../../ui/text';
import Input from '../../../ui/input';
import CheckboxGroup from '../../../ui/checkbox-group';
import * as lists from '../constants';
import { useFormContext } from "react-hook-form";
import { useTranslation } from 'react-i18next';

function AccessibilityInfo() {
  const { t } = useTranslation();
  const { 
    register,
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <>
      <section className="w-full">
        <h2 className="w-full text-2xl font-semibold opacity-[var(--sds-size-stroke-border)] text-sky-950 max-md:mt-10 max-md:ml-1">
          <Text>Language</Text>
        </h2>
        <div className="w-full grid grid-cols-12 gap-5 mt-5">
          <div className='col-span-12 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='language'>Language</Text>
            <div className="w-full max-w-sm">
              <Select
                {...register('language')}
                size='sm'
                label={<Text>Select</Text>}
                options={lists.language}
                selectionMode="single"
                isDisabled={lists.language?.length === 0}
                errorMessage={errors?.language?.message || null}
                isInvalid={errors?.language ? true : false}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="w-full mt-10">
        <h2 className="w-full text-2xl font-semibold opacity-[var(--sds-size-stroke-border)] text-sky-950 max-md:mt-10 max-md:ml-1">
          <Text>Accessibility</Text>
        </h2>
        <div className="w-full grid grid-cols-12 gap-6 mt-5">
          <div className='col-span-12 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='accessibleFormatsOptions'>Accessible Formats</Text>
            <div className="w-full max-w-sm">
              <Select
                {...register('accessibleFormatsOptions')}
                size='sm'
                label={t('Select')}
                options={lists.accessibleFormats}
                selectionMode="multiple"
                isDisabled={lists.accessibleFormats?.length === 0}
                errorMessage={errors?.accessibleFormatsOptions?.message || null}
                isInvalid={errors?.accessibleFormatsOptions ? true : false}
                isClearable={true}
              />
            </div>
          </div>
          <div className='col-span-12 flex flex-col justify-start items-start'>
            <div>
              <Text type='label' htmlFor='email' className='font-normal text-sm'>If you wish to receive materials electronically, please provide your </Text>
              <Text type='label' htmlFor='email'>email address.</Text>
            </div>
            <div className="w-full max-w-sm">
              <Input
                {...register('email')}
                size='sm'
                label={<Text>Email</Text>}
                placeholder="-"
                errorMessage={errors?.email?.message || null}
                isInvalid={errors?.email ? true : false}
              />
            </div>
          </div>
          <div className='col-span-12 flex flex-col justify-start items-start'>
            <div>
              <Text type='label' htmlFor='accessibilityOptions'>Select one or more</Text>
            </div>
            <div className="w-full mt-3">
              <CheckboxGroup
                control={control}
                name='accessibilityOptions'
                size='sm'
                options={lists.accessibilityOptionsList} 
                isInvalid={!!errors?.accessibilityOptions}
                errorMessage={errors?.accessibilityOptions?.message || null}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AccessibilityInfo;